<template>
    <div class="screenConfig-batch app-container">
        <div class="screenConfigBatch-tag bg-white">
            <tag :tagData="tagData" @tagEvn="tagEvn"/>      
        </div>
        <el-card class="screenConfig-batch-upload" :body-style="{ padding: '20px' }">
            <animation-upload @uploadSuccess="uploadSuccess" :title="$t('org.powerOn')"/>
            <animation-upload @uploadSuccess="uploadSuccess" :title="$t('org.standby')"/>
            <animation-upload @uploadSuccess="uploadSuccess" :title="$t('org.powerOff')"/>
        </el-card>
        
        <div class="screenConfig-batch-save">
            <el-button type="primary" @click="save">{{$t('commonMsg.save')}}</el-button>
        </div>
    </div>
</template>

<script>
import tag from '@/components/tag'
import animationUpload from '@/components/animationUpload'
export default {
    components: {
        tag,
        animationUpload
    },
    data() {
        return {
            tagData: null,
            tagArr: [],
            params: {}
        }
    },
    methods: {
        getTagList() {
            this.$http.getTagList()
            .then(res => {
                this.tagData = res.data.rows
            })
        },

        tagEvn(tagArr) {
            this.tagArr = tagArr
        },

         uploadSuccess(obj) {
            this.params = Object.assign(this.params, obj)
        },

        save() {
            if(!this.tagArr.length){
                this.elMsg(this.$t('alertMsg.selectTag'), 'warning')
                return;
            }else if(!Object.keys(this.params).length) {
                this.elMsg(this.$t('alertMsg.uploadTip'), 'warning')
                return;
            } 
            this.params.tag_id = this.tagArr.map(item => item.id)
            this.$http.batchAddScreen(this.params)
                .then(res => {
                    this.elMsg(this.$t('alertMsg.saveSuccess'), 'success')
                    this.$router.back()
                })
        }
    },

    mounted() {
        this.getTagList()
    }
}
</script>

<style lang="scss" scoped>
.screenConfigBatch-tag{
    padding:10px 20px;
    overflow: hidden;
} 
.screenConfig-batch-upload{
    margin:20px;
    overflow: hidden;
}
.screenConfig-batch-save{
    text-align: center;
    margin-bottom: 20px;
    .el-button {
        width:140px;
    }
}
</style>
